import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextInput } from "components/common/FormControls";
import { Button } from "@material-ui/core";
import isEmail from "validator/lib/isEmail";
import ButtonLoading from "components/common/LoadingIndicator/buttonLoading";

const FormStep7 = ({ styles, buttonName, handleFormChange, data, setStepNo, formData, inProcess, setInProcess }) => {
    const [petData, setPetData] = useState(data);
    const [fieldError, setFieldError] = useState({});
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);

    const checkFormInvalid = () => {
        const copyFormData = { ...petData };

        return Object.values(copyFormData).some((v) => v === null || `${v}`.trim() === "" || v === false);
    };

    const validateGetQuoteForm = () => {
        const isFormDataInvalid = !checkFormInvalid();

        return isFormDataInvalid;
    };

    const handleKeyupEmail = (e) => {
        const value = e.target.value;

        const isValidEmail = isEmail(value?.trim());

        setPetData({ ...petData, isValidEmail });
    };

    const handleOnChange = (e, value) => {
        setPetData({
            ...petData,
            [value.name]: value.value,
        });

        const copyFieldError = { ...fieldError };

        delete copyFieldError[value.name];

        setFieldError(copyFieldError);
    };

    const handleOnBlur = (e) => {
        const targetName = e.target.id;
        const value = e.target.value;

        const copyFieldError = { ...fieldError };

        if (value?.trim() === "") {
            copyFieldError[targetName] = true;
        } else {
            delete copyFieldError[targetName];
        }

        if (targetName === "email" && !petData.isValidEmail) {
            copyFieldError[targetName] = true;
        }

        setFieldError(copyFieldError);
    };

    const handleSubmit = () => {
        setInProcess(true);
        handleFormChange(petData);
        setStepNo(7);
    };

    useEffect(() => {
        const getValidators = () => [validateGetQuoteForm];

        const validators = getValidators();

        const isDisabled = validators.some((validator) => validator.call());

        setIsBtnDisabled(!isDisabled);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [petData]);

    const heading1 = `Great location. Let’s get ${formData.petName}’s quote then, shall we?`;
    const heading2 = `What’s <b>your email</b>?`;

    return (
        <>
            <div className="conversationalForm__container__formContainer__petData">
                <div className="conversationalForm__container__formContainer__petData__heading">
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__desktop"
                        dangerouslySetInnerHTML={{
                            __html: heading1,
                        }}
                    />
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__desktop"
                        dangerouslySetInnerHTML={{
                            __html: heading2,
                        }}
                    />
                    <div
                        className="conversationalForm__container__formContainer__petData__heading__mobile"
                        dangerouslySetInnerHTML={{
                            __html: `${heading1} ${heading2}`,
                        }}
                    />
                </div>
                <div className="conversationalForm__container__formContainer__petData__inputDiv">
                    <div className="conversationalForm__container__formContainer__petData__inputDiv__fieldGroup">
                        <TextInput
                            name="email"
                            value={petData.email}
                            onChange={handleOnChange}
                            identifier="email"
                            type="text"
                            inputVariant="filled"
                            inputLabel={"enter your email"}
                            onBlur={handleOnBlur}
                            onKeyUp={handleKeyupEmail}
                            error={
                                fieldError["email"] && petData.email.trim() === ""
                                    ? "Please enter your valid email address."
                                    : fieldError["email"] && petData.email.trim() !== ""
                                    ? "Oops! This isn't a valid email address."
                                    : false
                            }
                        />
                    </div>
                </div>
                <div className="conversationalForm__container__formContainer__petData__formProtect">
                    <img
                        src="https://fetch-sales-funnel.cdn.prismic.io/fetch-sales-funnel/82c8e30e-e21f-4b04-9ec5-77b241b0d8f6_privacy-lock-dodo.svg"
                        alt="img"
                    />
                    <span>We protect your privacy</span>
                </div>
                <div className="conversationalForm__container__formContainer__petData__button">
                    <Button
                        type="button"
                        size="large"
                        onClick={handleSubmit}
                        fullWidth
                        variant="contained"
                        disabled={isBtnDisabled}
                        id="submit"
                        className={inProcess ? `no-click submit-button` : "submit-button"}
                        style={isBtnDisabled ? { ...styles?.button?.disable } : { ...styles?.button?.active }}
                    >
                        {inProcess ? (
                            <span className="button-loading-content">
                                Loading
                                <ButtonLoading />
                            </span>
                        ) : (
                            <>{buttonName.trim() || "Get your free quote"}</>
                        )}
                    </Button>
                </div>
            </div>
        </>
    );
};

FormStep7.propTypes = {
    styles: PropTypes.object,
    buttonName: PropTypes.string,
    handleFormChange: PropTypes.func,
    data: PropTypes.object,
    setStepNo: PropTypes.func,
    formData: PropTypes.object,
    inProcess: PropTypes.bool,
    setInProcess: PropTypes.func,
};

export default FormStep7;
